import * as PROJECT_CODE from '../../constants/projectCode';
import * as DONE_ONCE from '../../constants/doneOnceJson';
import { GetClientDocumentData } from './getClientDocumentData';
import { isEmpty } from 'lodash';

export async function getAllSalesAgentsClient(
	firebase,
	setClientDetailList,
	setLoading
) {
	//const { firebase } = useContext(FirebaseContext);

	var currentUserId = firebase.auth().currentUser?.uid;

	window.clientDetailConst = await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.on('value', async (snapshot) => {
			var allVisibleClients = [];
			var nonVisibleClients = [];
			var currentClientList = [];

			
			var snapData = snapshot.val();
			console.log('getAllSalesAgentsClient snapData', snapData);

			var allKeys = snapData && Object.keys(snapData);
			console.log('getAllSalesAgentsClient allKeys', allKeys);

			//console.log('saveOrUpdateDocument key' + thisSalesAgentPointer);

			allKeys?.forEach((key) => {

				var thisSalesAgentPointer = key;
				var snapClients = snapData[key].myClients;
				var snapEmail = snapData[key].email;
				var snapName = snapData[key].name;

				console.log('getAllSalesAgentsClient myClients', snapClients);
				if (snapClients) {
					var snapClientsKeys = snapClients && Object.keys(snapClients);

					console.log(
						'getAllSalesAgentsClient snapClientsKeys',
						snapClientsKeys
					);

					for (var i = 0; i < snapClientsKeys.length; i++) {
						var aClient = snapClients[snapClientsKeys[i]];
						var isForCurrentSalesAgent;

						if (snapEmail === firebase.auth().currentUser.email) {
							isForCurrentSalesAgent = true;
						}
						console.log('getAllSalesAgentsClient aClient', aClient);

						console.log('snapClientsKeys[i]', snapClientsKeys[i]);

						aClient['keyValue'] = snapClientsKeys[i];
						aClient['salesAgentEmail'] = snapEmail;
						aClient['salesAgentName'] = snapName;
						aClient['salesAgentPointer'] = thisSalesAgentPointer;
						aClient['isForCurrentSalesAgent'] = isForCurrentSalesAgent;
						// aClient['keyValue'] = aClient?.keyValue;

						currentClientList.push(aClient);
					}
				}
			});

			console.log('currentClientList super admin', currentClientList);

			await pushToClient(
				firebase,
				currentClientList,
				(returned) => allVisibleClients.push(returned),
				(returned) => nonVisibleClients.push(returned)
			);

			console.log('Visible Client RECEIVED  1', allVisibleClients);

			setClientDetailList(allVisibleClients);
			setLoading(false);
		});
}

export async function pushToClient(
	firebase,
	currentClientList,
	allVisibleClients,
	nonVisibleClients
) {
	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(firebase, client).then((result) => {
				client['expandedClientInfo'] = result;
			});

			allVisibleClients(client);
		} else {
			nonVisibleClients(client);
		}
	}
}

export async function GetAllVisibleClientsForSpecificClient(firebase) {
	//const { firebase } = useContext(FirebaseContext);

	var allVisibleClients = [];
	var nonVisibleClients = [];

	var currentUserId = firebase.auth().currentUser?.uid;
	var currentClientList = [];

	var thisSalesAgentPointer;

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			//console.log("SnapData " +  JSON.stringify(snapData));

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			return thisSalesAgentPointer;
		});

	console.log('saveOrUpdateDocument key' + thisSalesAgentPointer);
	await firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		)
		.once('value', (snapshot) => {
			//console.log(JSON.stringify(snapshot.val()));
			snapshot.forEach((clientData) => {
				var aClient = clientData.val();

				aClient['keyValue'] = clientData.key;
				aClient['salesAgentPointer'] = thisSalesAgentPointer;

				//console.log(" Client email " + aClient.clientEmail + " id " + aClient.id + " client key " + clientData.key);
				currentClientList.push(aClient);
			});
		});

	//for(const client of currentClientList)

	//currentClientList.forEach(async (client) => {

	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(firebase, client).then((result) => {
				client['expandedClientInfo'] = result;

				//console.log("Current Client List Add to client " + JSON.stringify(result));
			});

			console.log('Adding client to list');

			allVisibleClients.push(client);
		} else {
			nonVisibleClients.push(client);
		}
	}

	console.log('Visible Client RECEIVED', allVisibleClients);

	return allVisibleClients;
}

export async function GetSpecificClient(firebase, _clientEmail) {
	var allClients;
	await GetAllVisibleClientsForSpecificClient(firebase).then((returned) => {
		allClients = returned;
	});

	var thisClient;

	allClients.forEach((client) => {
		if (client.clientEmail === _clientEmail) {
			thisClient = client;
		}
	});

	return thisClient;
}

export async function GetClientExpandedInfo(firebase, client) {
	// data-appcode={client.appCode}
	// data-keyvalue={client.keyValue}
	// data-salesagentpointer={client.salesAgentPointer}
	// data-name={client.fullName}
	// data-docsent={client?.documentInformation?.documentStatus}
	// data-clientemail={client.clientEmail}

	var dataSet = {
		appcode: client.appCode,
		keyvalue: client.keyValue,
		salesagentpointer: client.salesAgentPointer,
		name: client.fullName,
		docsent: client?.documentInformation?.documentStatus,
		clientemail: client.clientEmail,
	};

	var currentUserId = firebase.auth().currentUser?.uid;

	var clientExpanded;

	await GetClientDocumentData(firebase, dataSet, currentUserId).then(
		(result) => {
			clientExpanded = result;

			console.log( JSON.stringify(dataSet) + ' Super ReturnInfExpandedClients ' + JSON.stringify(result));
		}
	);

	return clientExpanded;
}
